<template>

  <div class="corretiva-defeito ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->


              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-defeito @click="loadGrupo()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">      
    </div>    
    <!--tbl de dados -->
    <b-table id="defeito"  small hover striped sticky-header="550px"  :items="defeitos" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editDefeito(data.item),loadGrupo(),loadSubGrupo()"    title="Editar Defeito"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-defeito>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO CORRETIVA -->
      <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO CORRETIVA -->
      <div>        
    <b-modal id="modal-multi-defeito"   hide-footer size="lg" title="Cadastro de defeitos">
          <!-- -->
          <div>
            <b-row>
              <b-col cols="6">
                <label for="input-grupo">Grupo</label> 
                <div>                
                  <b-form-select                  
                    v-model="defeito.grupo_id"                                                     
                    :options="grupos"
                    class="mb-3 "
                    text-field="grupo"
                    @change="loadSubGrupo()"
                    >                
                  </b-form-select>
                </div>
              </b-col> 

              <b-col cols="6">
                <label for="input-grupo">Subgrupo</label> 
                <div>                
                  <b-form-select                  
                    v-model="defeito.subgrupo_id"                                                     
                    :options="subgrupos"
                    class="mb-3 "
                    text-field="subgrupo"
                    >                
                  </b-form-select>
                </div>
              </b-col>   
            </b-row>

            <b-row>
              <b-col cols="6">
                <label for="input-live">Defeito</label>
                <b-form-input v-model="defeito.defeito" placeholder="Digite a descrição do defeito"></b-form-input>              
              </b-col> 

                            <b-col cols="2">
                <label for="input-live">Id_cod_Erp</label>
                <b-form-input v-model="defeito.id_defeito_erp" placeholder="id_erp"></b-form-input>              
              </b-col>   
    

              <b-col cols="2">                                              
                  <b-form-checkbox
                    id="APP-terminal" 
                    class="mb-3 mt-5"
                    v-model="defeito.ponto"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  APP-ponto 
                  </b-form-checkbox>                
              </b-col>

            <b-col cols="2">                                              
                  <b-form-checkbox
                    id="APP-status" 
                    class="mb-3 mt-5"
                    v-model="defeito.status"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Inativo 
                  </b-form-checkbox>                
              </b-col>



          </b-row>  
          <input  id="id-defeito" type="hidden" v-model="defeitos.id_defeito" />
         
             <b-button class="mt-3" variant="success" block @click="postDefeito()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex' 




export default {    
    name: 'ManutencaoSUBgrupo',  
    computed : { ... mapState (['user'],),} ,   

    data: function() {

        
      
        return {                        
            carregando: false,            
            grupos:[],                                
            subgrupos: [],   // [] lista   
            defeitos:[],
            defeito:{},
            
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [

                { key: 'empresa_id', label: 'Empresa', sortable: true },     
                { key: 'id', label: 'Id_defeito', sortable: true },     
                { key: 'defeito', label: 'Defeito', sortable: true },                                                       
                { key: 'grupo_id', label: 'Id_grupo', sortable: true },     
                { key: 'grupo', label: 'Grupo', sortable: true },   

                { key: 'subgrupo_id', label: 'Id_subgrupo', sortable: true },     
                { key: 'subgrupo', label: 'SubGrupo', sortable: true },                                         
                
                
                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, defeitos) => {
                    return moment(defeitos.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_alteracao', label: 'Data Alteracao', sortable: true, formatter: (value, key, defeitos) => {
                    return moment(defeitos.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'id_defeito_erp', label: 'ID_ERP', sortable: true },   


                { key: 'ponto', label: 'Exibe no APP-CORRETIVA', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
                { key: 'status', label: 'Ativo', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },

                { key: 'actions', label: 'Ações' },
                
            ]
        }        
    },

    components: {
        
    },
    methods: {

        ///GRUPO
        loadGrupo() {      
            let corpo = {    
                "id_empresa": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/manutencao/corretiva/listagem/grupo`
          axios.post(url,corpo)
               .then(res => {this.grupos = res.data.map(gru => {return { ... gru, value: gru.id_grupo, grupo: gru.grupo} })})
               .catch(showError)
          
        }, 

        ///SUBGRUPO
        loadSubGrupo() {   
          let corpo = {    
                "id_empresa": `${this.user.id_empresa}`,                                            
                "id_grupo": `${this.defeito.grupo_id}`,                                            
          };          
          const url = `${baseApiUrl}/manutencao/corretiva/listagem/subgrupo`
          axios.post(url,corpo)
               .then(res => {this.subgrupos = res.data.map(sb => {return { ... sb, value: sb.id, subgrupo: sb.subgrupo} })})
               .catch(showError)
        },
        
        ///DEFEITO
        loadDefeito() 
        {          
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                                                                   
          };          

          const url = `${baseApiUrl}/manutencao/corretiva/listagem/defeito`
          axios.post(url,corpo).then(res => {
            this.carregando = false;       
            this.defeitos = res.data.map(defeito => {              
              return { ... defeito}
            })
          })
        },  

        
        editDefeito(defeito){
            this.defeito = { ...defeito }
        },

          
        postDefeito() {                        
        let corpo = {                 
              "empresa_id": `${[this.user.id_empresa]}`,     
              "id_funcionario": `${[this.user.id_funcionario]}`,     
              "grupo_id": `${[this.defeito.grupo_id]}`,     
              "subgrupo_id": `${[this.defeito.subgrupo_id]}`,
              "id": `${[this.defeito.id]}`,
              "id_defeito_erp": `${[this.defeito.id_defeito_erp]}`,
              "defeito": `${[this.defeito.defeito]}`,
              "ponto":`${(this.defeito.ponto)?[this.defeito.ponto]:false}`,       
              "status":`${(this.defeito.status)?[this.defeito.status]:false}`            
        };

        const url = `${baseApiUrl}/manutencao/corretiva/defeito`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {  
            this.subgrup = {}          
            this.subgrupo = []
            this.defeito = []            
            //
            //this.loadGrupo()
            this.loadDefeito()            
        }
       
    },



    mounted() {  
      //this.loadGrupo()
      //this.loadSubGrupo()
      this.loadDefeito()
     
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#grupos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>